import React, { useState } from 'react';
import { Auth } from '../core/auth';
import { isSupabaseConfigured } from '../core/supabase-client';

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.083 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C33.64 6.053 28.991 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
      <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 16.108 18.961 13 24 13c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C33.64 6.053 28.991 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
      <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.048 0-9.449-3.317-10.956-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
      <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-1.093 3.131-3.226 5.657-6.084 7.57l6.19 5.238C39.697 37.594 44 31.138 44 24c0-1.341-.138-2.65-.389-3.917z" />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.365 1.43c0 1.14-.42 2.19-1.19 3-.84.88-2.22 1.56-3.41 1.47-.14-1.09.46-2.25 1.16-3.01.83-.89 2.28-1.53 3.44-1.46zM20.7 17.06c-.57 1.31-.85 1.9-1.58 3.06-1.03 1.57-2.48 3.53-4.28 3.54-1.6.01-2.01-1.04-4.18-1.03-2.17.01-2.63 1.05-4.23 1.03-1.79-.01-3.15-1.72-4.18-3.29-2.88-4.4-3.18-9.55-1.4-12.3 1.26-1.93 3.26-3.06 5.13-3.06 1.9 0 3.09 1.04 4.66 1.04 1.52 0 2.45-1.04 4.63-1.04 1.65 0 3.4.9 4.66 2.46-4.09 2.23-3.43 8.05.89 9.59z" />
    </svg>
  );
}

function OAuthButtons({ mode = 'login', onError, disabled }) {
  const [busy, setBusy] = useState(null);
  const enabled = isSupabaseConfigured();

  const run = async (provider) => {
    if (!enabled || disabled || busy) return;
    setBusy(provider);
    onError?.('');
    const result = await Auth.startOAuth(provider, mode);
    setBusy(null);
    if (result.error) onError?.(result.error);
  };

  if (!enabled) return null;

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '16px 0' }}>
        <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
        <span style={{ fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 1 }}>or</span>
        <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
      </div>
      <div style={{ display: 'grid', gap: 10 }}>
        <button
          type="button"
          className="btn btn-lg oauth-btn"
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, background: '#fff', border: '1px solid var(--border)', color: 'var(--ink)' }}
          onClick={() => run('google')}
          disabled={!!busy || disabled}
        >
          <GoogleIcon />
          {busy === 'google' ? 'Opening Google…' : 'Continue with Google'}
        </button>
        <button
          type="button"
          className="btn btn-lg oauth-btn"
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, background: '#111', border: '1px solid #111', color: '#fff' }}
          onClick={() => run('apple')}
          disabled={!!busy || disabled}
        >
          <AppleIcon />
          {busy === 'apple' ? 'Opening Apple…' : 'Continue with Apple'}
        </button>
      </div>
    </div>
  );
}

export { OAuthButtons };
